// import api from './api';
// const hasNumRegex = /.*[0-9].*/;


/**
 * @param {string} targets list of target strings
 * @returns {Promise<{[{target, valid}] }>}
 */
export default async function checkTargets(targets) {
    // Disabled due to third party API deactivation
    return targets.map(x => ({
        target: x,
        valid: true
    }));
    /*
    let { data } = await api.post('check_targets', targets);
    // QYL-7728: While soapbox allows numbers we have to disallow them.
    if (Array.isArray(data)) {
        data = data.map(t => {
            if (!t.valid || hasNumRegex.test(t.target))
                t.valid = false;
            return t;
        });
    }
    return data;
    */
}